<template>
  <div class="media-row">
    <div class="media">
      <span v-if="isOurCoin" class="mine-dot" title="Our coin"></span>
      <button v-if="mint" type="button" class="copy-btn" title="Coin actions" @click="$emit('actions')">⧉</button>
      <img v-if="imageSrc" :src="imageSrc" alt="" @error="imageFailed" />
      <span v-else class="fallback">🐸</span>
    </div>

    <div class="links">
      <a v-for="link in visibleLinks" :key="link.label" :href="link.href" target="_blank" rel="noopener noreferrer">{{ link.label }}</a>
    </div>
  </div>
</template>

<script setup>
import { computed, ref } from 'vue'
import { imageFailedSrc, safeImageSrc } from '@/composables/safeImage'
import { gmgnLink, solscanLink } from './utils'

const props = defineProps({
  mint: { type: String, default: '' },
  name: { type: String, default: '' },
  image: { type: String, default: '' },
  website: { type: String, default: '' },
  twitter: { type: String, default: '' },
  telegram: { type: String, default: '' },
  isOurCoin: { type: Boolean, default: false },
})

defineOptions({ name: 'CoinPadMedia' })

defineEmits(['actions'])

const badImage = ref('')
const imageSrc = computed(() => {
  return safeImageSrc(props.image, badImage.value)
})

const visibleLinks = computed(() => {
  const links = []
  if (props.mint) {
    links.push({ label: 'GMGN', href: gmgnLink(props.mint) })
    links.push({ label: 'Solscan', href: solscanLink(props.mint) })
  }
  if (props.website) links.push({ label: 'Website', href: props.website })
  if (props.twitter) links.push({ label: 'Twitter', href: props.twitter })
  else if (props.telegram) links.push({ label: 'Telegram', href: props.telegram })
  return links.slice(0, 4)
})

function imageFailed(event) {
  badImage.value = imageFailedSrc(event, imageSrc.value)
}
</script>

<style scoped>
.media-row{
  display:contents;
}

.media{
  grid-column:1;
  grid-row:1 / span 3;
  position:relative;
  width:112px;
  height:112px;
  border-radius:10px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display:flex;
  align-items:center;
  justify-content:center;
  font-weight:700;
  font-size:16px;
  color:#fff;
  overflow:hidden;
}
.copy-btn{
  position:absolute;
  right:6px;
  bottom:6px;
  z-index:3;
  width:24px;
  height:24px;
  padding:0;
  border-radius:999px;
  border:1px solid rgba(226,232,240,.35);
  background:rgba(15,23,42,.78);
  color:#e5e7eb;
  cursor:pointer;
  display:flex;
  align-items:center;
  justify-content:center;
  font-size:13px;
  line-height:1;
  backdrop-filter:blur(6px);
}
.copy-btn:hover{
  border-color:#93c5fd;
  background:rgba(30,41,59,.9);
}
.mine-dot{
  position:absolute;
  top:6px;
  left:6px;
  width:10px;
  height:10px;
  border-radius:999px;
  background:#facc15;
  box-shadow:0 0 10px rgba(250,204,21,.8);
  z-index:2;
}
.media > img{ width:100%; height:100%; object-fit:cover; }
.fallback{ font-size:30px; line-height:1; }

.links{
  grid-column:2;
  grid-row:2;
  width:100%;
  display:flex;
  flex-wrap:wrap;
  gap:6px;
  min-width:0;
}
.links a,
.link-btn{
  font-size:11px;
  padding:4px 10px;
  border-radius:999px;
  border:1px solid #374151;
  background:#111827;
  color:#e5e7eb;
  text-decoration:none;
  line-height:1.25;
  cursor:pointer;
  text-align:center;
  overflow:hidden;
  text-overflow:ellipsis;
  white-space:nowrap;
}
.links a:hover,
.link-btn:hover{ border-color:#6366f1; }

@media (max-width: 640px) {
  .media-row{
    display:contents;
  }
  .media{ width:88px; height:88px; border-radius:9px; }
  .links{
    width:100%;
    display:flex;
    flex-wrap:wrap;
    gap:5px;
  }
  .links a,
  .link-btn{
    font-size:10px;
    padding:4px 8px;
  }
}
</style>
